'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:waypoint-portal-app":true});}catch(e){}}();

import { useEffect } from 'react';

import { BaseAuthErrorPage, Button } from '@components';
import { IconUndo } from '@endurancewarranty/icons';
import { useSentry } from '@lib/hooks';

import type { FC } from 'react';

type Props = Readonly<{
  error: Error;
  digest?: string;
}>;

const GlobalError: FC<Props> = ({ error }) => {
  const { captureException } = useSentry();

  useEffect(() => {
    captureException(error);
  }, [captureException, error]);

  return (
    <html>
      <body className="h-screen w-screen">
        <BaseAuthErrorPage
          title="Unexpected Error"
          message="Please refresh the page to continue."
          action={
            <Button
              onClick={() => {
                try {
                  localStorage.clear();
                  sessionStorage.clear();
                } catch {
                  // Ignore storage errors; still attempt a full reload.
                } finally {
                  window.location.reload();
                }
              }}
              variant="secondary-dark">
              <IconUndo className="mr-2 h-4 w-4" />
              Refresh
            </Button>
          }
        />
      </body>
    </html>
  );
};

export default GlobalError;
